// extracted by mini-css-extract-plugin
module.exports = {"not-found":"NotFound_not-found__2ZbKq","button":"NotFound_button__3JZdL"};